module.exports = __webpack_public_path__ + "static/img/jx-sjt(jndy).3c646cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-sjt(jndy).png
// module id = V3xx
// module chunks = 0